export const GREEN = "#70c18a";
export const PRIMARY = "rgb(89, 86, 233)";
